// Module
var code = "<code-editor class=\"code-editor kform-script-editor\" on-editor-ready=\"$ctrl.onEditorReady(editor)\" on-setup=\"$ctrl.onEditorSetup()\" ng-style=\"$ctrl.aceStyles\" ng-readonly=\"$ctrl.readonly\" ng-disabled=\"$ctrl.disabled\" ng-model=\"$ctrl.ngModel\"></code-editor> ";
// Exports
export default code;